// client config is not working currently.  I am told anything in the FLAVOR config will not work correctly.
// Use server config instead.
const cssVersionMap = require('../versions');

module.exports = {
  loggingService: {
    enableRemoteLogging: true,
    enableConsole: false,
  },
  attachments: {
    maxSize: 25 * 1024 * 1024, // 25MB
  },
  errorViewCssUrl: `https://vap.expedia.com/c3cards/${cssVersionMap.errorView}/payment-{{brand}}.css`, // Duplicated in server configuration
  axios: {
    defaultTimeout: 60000,
    webAdapterTimeout: 210000,
    flightsChangeWebAdapterTimeout: 180000,
  },
  edgetoken: {
    timeout: 120000,
    maxRetry: 3,
    retries: 3,
    partnerId: 'voyager-next', // partnerId from edge-tokenizer, nonce is for voyager-next
    actions: {
      GET_EDGE_NONCE: {
        method: 'GET',
        url: '/edgetoken/nonce',
      },
      GET_EDGE_TOKEN: {
        method: 'POST',
        url: '/browser/v1/edge-tokens',
      },
    },
  },
  axiosRetry: {
    retries: 2,
    shouldResetTimeout: true,
  },
};
